export * from "./api";
export * from "./router";

export const escapeText = (str: string) => {
    return str.replace(/[&<>"']/g, (key: string) => {
        switch (key) {
            case "&":
                return "&amp;";
            case "<":
                return "&lt;";
            case ">":
                return "&gt;";
            case '"':
                return "&quot;";
            case "'":
                return "&#39;";
            default:
                return "";
        }
    });
};

export const gainID = () => {
    var d = new Date().getTime();
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
};

//* 对照表
export const Contrast = {
    //* 蛋白质
    Protein: <{ [name: string]: { name: string; codons: string[]; fullname: string; shortnanme: string } }>{
        "A": { name: "A", codons: ["GCT", "GCC", "GCA", "GCG"], fullname: "Alanine", shortnanme: "Ala" },
        "R": { name: "R", codons: ["CGT", "CGC", "CGA", "CGG", "AGA", "AGG"], fullname: "Arginine", shortnanme: "Arg" },
        "N": { name: "N", codons: ["AAT", "AAC"], fullname: "Asparagine", shortnanme: "Asn" },
        "D": { name: "D", codons: ["GAT", "GAC"], fullname: "Aspartic acid", shortnanme: "Asp" },
        "C": { name: "C", codons: ["TGT", "TGC"], fullname: "Cysteine", shortnanme: "Cys" },
        "Q": { name: "Q", codons: ["CAA", "CAG"], fullname: "Glutamine", shortnanme: "Gln" },
        "E": { name: "E", codons: ["GAA", "GAG"], fullname: "Glutamic acid", shortnanme: "Glu" },
        "G": { name: "G", codons: ["GGT", "GGC", "GGA", "GGG"], fullname: "Glycine", shortnanme: "Gly" },
        "H": { name: "H", codons: ["CAT", "CAC"], fullname: "Histidine", shortnanme: "His" },
        "I": { name: "I", codons: ["ATT", "ATC", "ATA"], fullname: "Isoleucine", shortnanme: "Ile" },
        "L": { name: "L", codons: ["CTT", "CTC", "CTA", "CTG", "TTA", "TTG"], fullname: "Leucine", shortnanme: "Leu" },
        "K": { name: "K", codons: ["AAA", "AAG"], fullname: "Lysine", shortnanme: "Lys" },
        "M": { name: "M", codons: ["ATG"], fullname: "Methionine", shortnanme: "Met" },
        "F": { name: "F", codons: ["TTT", "TTC"], fullname: "Phenylalanine", shortnanme: "Phe" },
        "P": { name: "P", codons: ["CCT", "CCC", "CCA", "CCG"], fullname: "Proline", shortnanme: "Pro" },
        "S": { name: "S", codons: ["TCT", "TCC", "TCA", "TCG", "AGT", "AGC"], fullname: "Serine", shortnanme: "Ser" },
        "T": { name: "T", codons: ["ACT", "ACC", "ACA", "ACG"], fullname: "Threonine", shortnanme: "Thr" },
        "W": { name: "W", codons: ["TGG"], fullname: "Tryptophan", shortnanme: "Trp" },
        "Y": { name: "Y", codons: ["TAT", "TAC"], fullname: "Tyrosine", shortnanme: "Tyr" },
        "*": { name: "*", codons: ["TAA", "TAG", "TGA"], fullname: "Termination codon", shortnanme: "TERM" },
        "V": { name: "V", codons: ["GTT", "GTC", "GTA", "GTG"], fullname: "Valine", shortnanme: "Val" },
    },

    //* 密码子对照表
    Codon: <{ [name: string]: { name: string; codons: string[]; fullname: string; shortnanme: string } }>{
        TTT: { name: "F", codons: ["TTT", "TTC"], fullname: "Phenylalanine", shortnanme: "Phe" },
        TTC: { name: "F", codons: ["TTT", "TTC"], fullname: "Phenylalanine", shortnanme: "Phe" },
        TTA: { name: "L", codons: ["CTT", "CTC", "CTA", "CTG", "TTA", "TTG"], fullname: "Leucine", shortnanme: "Leu" },
        TTG: { name: "L", codons: ["CTT", "CTC", "CTA", "CTG", "TTA", "TTG"], fullname: "Leucine", shortnanme: "Leu" },
        CTT: { name: "L", codons: ["CTT", "CTC", "CTA", "CTG", "TTA", "TTG"], fullname: "Leucine", shortnanme: "Leu" },
        CTC: { name: "L", codons: ["CTT", "CTC", "CTA", "CTG", "TTA", "TTG"], fullname: "Leucine", shortnanme: "Leu" },
        CTA: { name: "L", codons: ["CTT", "CTC", "CTA", "CTG", "TTA", "TTG"], fullname: "Leucine", shortnanme: "Leu" },
        CTG: { name: "L", codons: ["CTT", "CTC", "CTA", "CTG", "TTA", "TTG"], fullname: "Leucine", shortnanme: "Leu" },
        AGT: { name: "S", codons: ["TCT", "TCC", "TCA", "TCG", "AGT", "AGC"], fullname: "Serine", shortnanme: "Ser" },
        AGC: { name: "S", codons: ["TCT", "TCC", "TCA", "TCG", "AGT", "AGC"], fullname: "Serine", shortnanme: "Ser" },
        TCT: { name: "S", codons: ["TCT", "TCC", "TCA", "TCG", "AGT", "AGC"], fullname: "Serine", shortnanme: "Ser" },
        TCC: { name: "S", codons: ["TCT", "TCC", "TCA", "TCG", "AGT", "AGC"], fullname: "Serine", shortnanme: "Ser" },
        TCA: { name: "S", codons: ["TCT", "TCC", "TCA", "TCG", "AGT", "AGC"], fullname: "Serine", shortnanme: "Ser" },
        TCG: { name: "S", codons: ["TCT", "TCC", "TCA", "TCG", "AGT", "AGC"], fullname: "Serine", shortnanme: "Ser" },
        TAT: { name: "Y", codons: ["TAT", "TAC"], fullname: "Tyrosine", shortnanme: "Tyr" },
        TAC: { name: "Y", codons: ["TAT", "TAC"], fullname: "Tyrosine", shortnanme: "Tyr" },
        TGT: { name: "C", codons: ["TGT", "TGC"], fullname: "Cysteine", shortnanme: "Cys" },
        TGC: { name: "C", codons: ["TGT", "TGC"], fullname: "Cysteine", shortnanme: "Cys" },
        CCT: { name: "P", codons: ["CCT", "CCC", "CCA", "CCG"], fullname: "Proline", shortnanme: "Pro" },
        CCC: { name: "P", codons: ["CCT", "CCC", "CCA", "CCG"], fullname: "Proline", shortnanme: "Pro" },
        CCA: { name: "P", codons: ["CCT", "CCC", "CCA", "CCG"], fullname: "Proline", shortnanme: "Pro" },
        CCG: { name: "P", codons: ["CCT", "CCC", "CCA", "CCG"], fullname: "Proline", shortnanme: "Pro" },
        CAT: { name: "H", codons: ["CAT", "CAC"], fullname: "Histidine", shortnanme: "His" },
        CAC: { name: "H", codons: ["CAT", "CAC"], fullname: "Histidine", shortnanme: "His" },
        CAA: { name: "Q", codons: ["CAA", "CAG"], fullname: "Glutamine", shortnanme: "Gln" },
        CAG: { name: "Q", codons: ["CAA", "CAG"], fullname: "Glutamine", shortnanme: "Gln" },
        AGA: { name: "R", codons: ["CGT", "CGC", "CGA", "CGG", "AGA", "AGG"], fullname: "Arginine", shortnanme: "Arg" },
        AGG: { name: "R", codons: ["CGT", "CGC", "CGA", "CGG", "AGA", "AGG"], fullname: "Arginine", shortnanme: "Arg" },
        CGT: { name: "R", codons: ["CGT", "CGC", "CGA", "CGG", "AGA", "AGG"], fullname: "Arginine", shortnanme: "Arg" },
        CGC: { name: "R", codons: ["CGT", "CGC", "CGA", "CGG", "AGA", "AGG"], fullname: "Arginine", shortnanme: "Arg" },
        CGA: { name: "R", codons: ["CGT", "CGC", "CGA", "CGG", "AGA", "AGG"], fullname: "Arginine", shortnanme: "Arg" },
        CGG: { name: "R", codons: ["CGT", "CGC", "CGA", "CGG", "AGA", "AGG"], fullname: "Arginine", shortnanme: "Arg" },
        ATT: { name: "I", codons: ["ATT", "ATC", "ATA"], fullname: "Isoleucine", shortnanme: "Ile" },
        ATC: { name: "I", codons: ["ATT", "ATC", "ATA"], fullname: "Isoleucine", shortnanme: "Ile" },
        ATA: { name: "I", codons: ["ATT", "ATC", "ATA"], fullname: "Isoleucine", shortnanme: "Ile" },
        ACT: { name: "T", codons: ["ACT", "ACC", "ACA", "ACG"], fullname: "Threonine", shortnanme: "Thr" },
        ACC: { name: "T", codons: ["ACT", "ACC", "ACA", "ACG"], fullname: "Threonine", shortnanme: "Thr" },
        ACA: { name: "T", codons: ["ACT", "ACC", "ACA", "ACG"], fullname: "Threonine", shortnanme: "Thr" },
        ACG: { name: "T", codons: ["ACT", "ACC", "ACA", "ACG"], fullname: "Threonine", shortnanme: "Thr" },
        AAT: { name: "N", codons: ["AAT", "AAC"], fullname: "Asparagine", shortnanme: "Asn" },
        AAC: { name: "N", codons: ["AAT", "AAC"], fullname: "Asparagine", shortnanme: "Asn" },
        AAA: { name: "K", codons: ["AAA", "AAG"], fullname: "Lysine", shortnanme: "Lys" },
        AAG: { name: "K", codons: ["AAA", "AAG"], fullname: "Lysine", shortnanme: "Lys" },
        GTT: { name: "V", codons: ["GTT", "GTC", "GTA", "GTG"], fullname: "Valine", shortnanme: "Val" },
        GTC: { name: "V", codons: ["GTT", "GTC", "GTA", "GTG"], fullname: "Valine", shortnanme: "Val" },
        GTA: { name: "V", codons: ["GTT", "GTC", "GTA", "GTG"], fullname: "Valine", shortnanme: "Val" },
        GTG: { name: "V", codons: ["GTT", "GTC", "GTA", "GTG"], fullname: "Valine", shortnanme: "Val" },
        GCT: { name: "A", codons: ["GCT", "GCC", "GCA", "GCG"], fullname: "Alanine", shortnanme: "Ala" },
        GCC: { name: "A", codons: ["GCT", "GCC", "GCA", "GCG"], fullname: "Alanine", shortnanme: "Ala" },
        GCA: { name: "A", codons: ["GCT", "GCC", "GCA", "GCG"], fullname: "Alanine", shortnanme: "Ala" },
        GCG: { name: "A", codons: ["GCT", "GCC", "GCA", "GCG"], fullname: "Alanine", shortnanme: "Ala" },
        GAT: { name: "D", codons: ["GAT", "GAC"], fullname: "Aspartic acid", shortnanme: "Asp" },
        GAC: { name: "D", codons: ["GAT", "GAC"], fullname: "Aspartic acid", shortnanme: "Asp" },
        GAA: { name: "E", codons: ["GAA", "GAG"], fullname: "Glutamic acid", shortnanme: "Glu" },
        GAG: { name: "E", codons: ["GAA", "GAG"], fullname: "Glutamic acid", shortnanme: "Glu" },
        GGT: { name: "G", codons: ["GGT", "GGC", "GGA", "GGG"], fullname: "Glycine", shortnanme: "Gly" },
        GGC: { name: "G", codons: ["GGT", "GGC", "GGA", "GGG"], fullname: "Glycine", shortnanme: "Gly" },
        GGA: { name: "G", codons: ["GGT", "GGC", "GGA", "GGG"], fullname: "Glycine", shortnanme: "Gly" },
        GGG: { name: "G", codons: ["GGT", "GGC", "GGA", "GGG"], fullname: "Glycine", shortnanme: "Gly" },
        TGG: { name: "W", codons: ["TGG"], fullname: "Tryptophan", shortnanme: "Trp" },
        ATG: { name: "M", codons: ["ATG"], fullname: "Methionine", shortnanme: "Met" },
        TAA: { name: "*", codons: ["TAA", "TAG", "TGA"], fullname: "Termination codon", shortnanme: "TERM" },
        TAG: { name: "*", codons: ["TAA", "TAG", "TGA"], fullname: "Termination codon", shortnanme: "TERM" },
        TGA: { name: "*", codons: ["TAA", "TAG", "TGA"], fullname: "Termination codon", shortnanme: "TERM" },
    },
};
